const missingKeys = new Set<string>();

interface ReportMissingKeyParams {
  key: string;
  logMissingKeys: (missingKeys: string[]) => void;
}

let timeout: number;

export const reportMissingKey = ({ key, logMissingKeys }: ReportMissingKeyParams) => {
  clearTimeout(timeout);
  missingKeys.add(key);

  timeout = window.setTimeout(() => {
    const missingKeysArr = Array.from(missingKeys).sort((a, b) => a.localeCompare(b));

    logMissingKeys(missingKeysArr);
  }, 500);
};
